export class Location 
{
id : number; 
addr1 : string; 
addr2 : string; 
City: string; 
Country: string;    
contact_name : string;
phone_number : string; 
email : string;

}